
import styles from "../pages/Footer.module.css";
import logo from "../media/cart7_logo_black.png";

function Footer () {
  return(
    <>
    <div className={styles.footerWrapper}>
      <div className={styles.line}><img className={styles.logo} alt="footer logo" src={logo} />© {new Date().getFullYear()} - All rights reserved.</div>
      <div className={styles.line}>
        <a className={styles.footerLink} href="/terms">Terms of Use</a>
        <a className={styles.footerLink} href="/privacy">Privacy Policy</a>
        <a className={styles.footerLink} href="/refund">Refund Policy</a>
        <a className={styles.footerLink} href="/shipping">Shipping Policy</a>
        <a className={styles.footerLink} href="/contact">Contact Us</a>
      </div>
    </div>
    </>
    );
}
export default Footer;